import { createGLightbox } from './lib/glightbox';

class FlyShippingDocuments {
	init() {
		const wrapper = document.querySelector('.page-template-template-shipping-documents .examples');
		if (!wrapper) {
			return;
		}

		createGLightbox({
			selector: '.page-template-template-shipping-documents .js-lightboxTrigger',
			touchNavigation: true,
			loop: true,
		});
	}
}

new FlyShippingDocuments().init();
